import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between bd-highlight mb-3" }
const _hoisted_3 = {
  class: "align-self-center mb-3",
  style: {"height":"30px"}
}
const _hoisted_4 = {
  class: "input-group align-self-center ms-auto p-2 bd-highlight",
  style: {"width":"40%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", {
  key: "100",
  value: ""
}, "全部", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "table table-bordered table-striped table-sm member-list" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, " 序号"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"200px"} }, "门店"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"350px"} }, "标题"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"350px"} }, "项目"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"100px"} }, "价格"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"80px"} }, "次数"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"200px"} }, "备注"),
    /*#__PURE__*/_createElementVNode("th", null, "状态"),
    /*#__PURE__*/_createElementVNode("th", null, "操作")
  ])
], -1)
const _hoisted_9 = { id: "member-list" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex-colum" }
const _hoisted_13 = { class: "mb-1 form-switch" }
const _hoisted_14 = ["checked", "onChange"]
const _hoisted_15 = { class: "flex-row flex-align-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_AddPackDialog = _resolveComponent("AddPackDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openAddPackDialog && $setup.openAddPackDialog(...args)))
          }, "添加")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("select", {
          class: "form-select w-40",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shopId) = $event))
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shopDataList, (value, idx) => {
            return (_openBlock(), _createElementBlock("option", {
              key: idx,
              value: value.id
            }, _toDisplayString(value.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.shopId]
        ]),
        _withDirectives(_createElementVNode("input", {
          style: {"left":"10px","right":"10px"},
          type: "text",
          id: "article-keywords",
          class: "form-control w-30",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keywords) = $event)),
          placeholder: "标题"
        }, null, 512), [
          [_vModelText, _ctx.keywords]
        ]),
        _createElementVNode("button", {
          class: "btn btn-secondary",
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.searchChankangPack && $setup.searchChankangPack(...args)))
        }, "搜索"),
        _createTextVNode("   "),
        _createElementVNode("button", {
          class: "btn btn-info",
          type: "button",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.exportAll && $setup.exportAll(...args)))
        }, "导出")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("tbody", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataList, (value, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("td", null, _toDisplayString(50 * ($setup.nowPage - 1) + idx + 1), 1),
                (value.shopList)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.shopList, (v, iii) => {
                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString($setup.getShopName(v)), 1))
                      }), 256))
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString($setup.getShopName(value.shop)), 1)),
                _createElementVNode("td", null, _toDisplayString(value.title), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.meals, (v, iii) => {
                      return (_openBlock(), _createElementBlock("div", null, _toDisplayString(v.title), 1))
                    }), 256))
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(value.price), 1),
                _createElementVNode("td", null, _toDisplayString(value.count) + "次", 1),
                _createElementVNode("td", null, _toDisplayString(value.remark), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      checked: value.show !== 0,
                      onChange: ($event: any) => ($setup.updateItem(value, 'show')),
                      type: "checkbox",
                      role: "switch"
                    }, null, 40, _hoisted_14)
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "button-icon",
                      src: "/assets/ic_edit.png",
                      onClick: ($event: any) => ($setup.openEditPackDialog(value.id))
                    }, null, 8, _hoisted_16),
                    _createElementVNode("img", {
                      class: "button-icon img-margin",
                      src: "/assets/ic_trash.png",
                      onClick: ($event: any) => ($setup.deletePack(value.id, value.title))
                    }, null, 8, _hoisted_17)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_Pagination, {
          page: $setup.nowPage,
          max: $setup.totalPage/50,
          onLoadPage: $setup.loadPackList
        }, null, 8, ["page", "max", "onLoadPage"])
      ])
    ]),
    _createVNode(_component_AddPackDialog, {
      ref: "addDialogRef",
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddDialog = false)),
      onConfirm: $setup.editPack
    }, null, 8, ["show", "item", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}